<template>
  <div>
    <xm-dialog title="导出历史" width="900px" @close-dialog="closeFunc">
      <div class="content">
        <xm-table
          :isCheckbox="false"
          :tableFiled="tableConfig"
          :table="exportList"
        >
          <div slot="operaSlot" slot-scope="{ row }">
            <span
              v-if="row.row.status_name == '已完成'"
              @click="handlerDown(row.row)"
              class="down-style"
            >
              文件下载
            </span>
          </div>
        </xm-table>
        <div class="page-model">
          <XmPaged
            :pagesize="pageSize"
            :pages="pages"
            :total="total"
            @go-pages="gopage"
          ></XmPaged>
        </div>
      </div>
    </xm-dialog>
  </div>
</template>
<script>
import { getExportTaskList } from '@/utils/api/common.js';
export default {
  data() {
    return {
      exportList: [], // 导出列表
      isShow: false,
      tableConfig: [
        {
          text: '任务创建时间',
          filed: 'creation_time',
          width: '185px',
          isSort: false,
        },
        {
          text: '任务ID',
          filed: 'task_id',
          width: '185px',
          isSort: false,
        },
        {
          text: '导出申请人',
          filed: 'export_applicant',
          width: '185px',
          isSort: false,
        },
        {
          text: '任务状态',
          filed: 'status_name',
          width: '185px',
          isSort: false,
        },
        {
          text: '操作',
          filed: 'opera',
          width: '120px',
          isSort: false,
          isEdit: true,
        },
      ],
      total: 0, // 总数
      pages: 1, // 当前页码
    };
  },
  mounted() {
    this.exportTaskList();
  },
  props: {
    // 这是后端决定的
    type: {
      type: [Number, String],
      default: 2,
    },
    // 每页大小
    pageSize: {
      type: Number,
      default: 12,
    },
    other_type: {
      type: [Number, String],
      default: '',
    },
  },
  methods: {
    handlerDown(rowInfo) {
      let curfileName = this.publicSetFileName(rowInfo.url, '', this.type);
      if ((this.type = '31' && this.other_type == '1')) {
        curfileName = this.publicSetFileName(
          rowInfo.url,
          '供应商充值记录导出',
          this.type
        );
      }
      this.down(rowInfo.url, curfileName);
    },
    exportTaskList() {
      let option = {
        type: this.type,
        pageSize: this.pageSize,
        pageNum: this.pages,
        MUTE_WARNING: 1,
      };
      if (this.other_type) {
        option.other_type = this.other_type;
      }
      getExportTaskList(option)
        .then((res) => {
          if (res.code == 200) {
            this.exportList = res.data.list;
            this.total = res.data.total;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    gopage(page) {
      this.pages = Number(page);
      this.exportTaskList();
    },
    closeFunc() {
      this.$emit('closeHistory');
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 900px;
  box-sizing: border-box;
  padding: 20px;
  .page-model {
    display: flex;
    justify-content: center;
    margin: 25px auto 10px auto;
  }

  .down-style {
    text-decoration: none;
    color: #026bff;
    cursor: pointer;
  }
}
</style>
